module.exports = __webpack_public_path__ + "static/montaggio-b116435d2283ce4aa29e115dd8aad84a.jpg";